import { Typography } from "@/core/components/ui/typography";

interface HarnessChatSuggestedPromptsProps {
  prompts: string[];
  disabled: boolean;
  onSend: (prompt: string) => void;
}

export const HarnessChatSuggestedPrompts = ({
  prompts,
  disabled,
  onSend,
}: HarnessChatSuggestedPromptsProps) => (
  <div className="space-y-3 py-2">
    <Typography
      variant="captionW1SemiBold"
      textColor="tertiary"
      className="uppercase tracking-wide"
    >
      Example Questions
    </Typography>
    {prompts.map((prompt) => (
      <button
        key={prompt}
        type="button"
        disabled={disabled}
        onClick={() => onSend(prompt)}
        className="w-full rounded-md border border-stroke-secondary bg-background px-3 py-2.5 text-left text-sm font-medium text-primary-text transition-colors hover:bg-surface-secondary disabled:opacity-50"
      >
        {prompt}
      </button>
    ))}
  </div>
);
